import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { CopyBlock, dracula } from "react-code-blocks";

const JavaScriptLesson11 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
  //global variable
  let name = "Sunday Nwachukwu";

  function sayHello(){
    let greeting = "Hello";
    console.log(greeting);
    console.log(name);
  }

  sayHello();
  console.log(greeting) //Can't find variable
  `
  );
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <div className="alert alert-secondary" role="alert">
    <h3><strong>Variable Scope</strong></h3>
    <p>The scope of a variable is the region of your program in which it is defined.</p>
    <p>JavaScript variables have only two scopes:</p>
    <ol class="list-group mb-4">
      <li class="list-group-item"><strong>Global Variables:</strong> A global variable can be declared and called anywhere in your JavaScript code.</li>
      <li class="list-group-item"><strong>Local Variables</strong> A local variable will be visible only within a function where it is defined.</li>
    </ol>
    </div>

    <div className="alert alert-secondary" role="alert">
    <CopyBlock
    language={language}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    <p className="mt-3">The variable <strong>greeting</strong> is a local variable because it is enclosed in a function. Any attempt to use outside of the declared function will result in error.</p>
    </div>
    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson11
